<!--=================================
=            ECHARTSAREA            =
==================================-->

<template>
 <div id="echart1" style="mx-width: 1000px;height:300px;"></div>
</template>

<script>
export default {
  mounted(){
  var option = {
        color: ['#66b2b2', '#004c4c'],
        title: {
          show: false
        },
        tooltip: {
          show: false,

        },
        legend: {
          show: false
        },
        toolbox: {
          show: false,
          feature: {
            saveAsImage: {}
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun']
        }],
        yAxis: [{
          type: 'value'
        }],
        series: [{
            name: '',
            type: 'line',
            stack: 'Total',
            symbolSize: 10,
            symbol: 'circle',
            smooth: true,
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#004c4c'
                },
                {
                  offset: 1,
                  color: '#004c4c'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: [140, 232, 101, 264, 90, 340, 250]
          },
          
          {
            name: '',
            type: 'line',
            stack: 'Total',
            symbolSize: 10,
            symbol: 'circle',
            smooth: true,
            lineStyle: {
              width: 3,
              shadowColor: 'rgba(0,0,0,0.3)',
              shadowBlur: 10,
              shadowOffsetY: 8
            },
            showSymbol: false,
            areaStyle: {
              opacity: 0.8,
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                  offset: 0,
                  color: '#66b2b2'
                },
                {
                  offset: 1,
                  color: '#66b2b2'
                }
              ])
            },
            emphasis: {
              focus: 'series'
            },
            data: [320, 132, 201, 334, 190, 130, 220]
          }
        ]
      };
      var chart1 = document.getElementById('echart1');
      var areaChart = echarts.init(chart1);
      areaChart.setOption(option)
  }
}
</script>

<!--====  End of ECHARTSAREA  ====-->
